import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "boolean-feature-flags"
    }}>{`Boolean feature flags`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`if (PostHogSDK.shared.isFeatureEnabled("flag-key")) {
    // Do something differently for this user

    // Optional: fetch the payload
    let matchedFlagPayload = PostHogSDK.shared.getFeatureFlagPayload("flag-key")
}
`}</code></pre>
    <h3 {...{
      "id": "multivariate-feature-flags"
    }}>{`Multivariate feature flags`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`if (PostHogSDK.shared.getFeatureFlag("flag-key") as? String == "variant-key") { // replace "variant-key" with the key of your variant
    // Do something differently for this user

    // Optional: fetch the payload
    let matchedFlagPayload = PostHogSDK.shared.getFeatureFlagPayload("flag-key")
}
`}</code></pre>
    <h3 {...{
      "id": "reloading-feature-flags"
    }}>{`Reloading feature flags`}</h3>
    <p>{`Feature flag values are cached. If something has changed with your user and you'd like to refetch their flag values, call:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`PostHogSDK.shared.reloadFeatureFlags()
`}</code></pre>
    <h3 {...{
      "id": "ensuring-flags-are-loaded-before-usage"
    }}>{`Ensuring flags are loaded before usage`}</h3>
    <p>{`Every time a user opens the app, we send a request in the background to fetch the feature flags that apply to that user. We store those flags in the storage.`}</p>
    <p>{`This means that for most screens, the feature flags are available immediately – `}<strong parentName="p">{`except for the first time a user visits`}</strong>{`.`}</p>
    <p>{`To handle this, you can use the `}<inlineCode parentName="p">{`didReceiveFeatureFlags`}</inlineCode>{` notification to wait for the feature flag request to finish:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`class AppDelegate: NSObject, UIApplicationDelegate {
    func application(_ application: UIApplication, didFinishLaunchingWithOptions launchOptions: [UIApplication.LaunchOptionsKey : Any]? = nil) -> Bool {
        // register for \`didReceiveFeatureFlags\` notification before SDK initialization
        NotificationCenter.default.addObserver(
            self,
            selector: #selector(receiveFeatureFlags),
            name: PostHogSDK.didReceiveFeatureFlags,
            object: nil
        )

        let POSTHOG_API_KEY = "<ph_project_api_key>"
        // usually 'https://us.i.posthog.com' or 'https://eu.i.posthog.com'
        let POSTHOG_HOST = "https://us.i.posthog.com"

        let config = PostHogConfig(apiKey: POSTHOG_API_KEY, host: POSTHOG_HOST)

        PostHogSDK.shared.setup(config)

        return true
    }

    // The "receiveFeatureFlags" method will be called when the SDK receives the feature flags from the server.
    @objc func receiveFeatureFlags() {
        print("receiveFeatureFlags called")
    }
}
`}</code></pre>
    <p>{`Alternatively, you can use the completion block of the `}<inlineCode parentName="p">{`reloadFeatureFlags(_:)`}</inlineCode>{` method. This allows you to execute logic immediately after the flags are reloaded:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`// Reload feature flags and check if a specific feature is enabled
PostHogSDK.shared.reloadFeatureFlags {
    if PostHogSDK.shared.isFeatureEnabled("flag-key") {
        // do something
    }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      